import * as React from 'react';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { KeyboardArrowDown } from '@mui/icons-material';
import Chip from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';

import styles from './styles.pcss';

export function NoOptionsMessage(props: any) {
  return (
    <Typography
      color="textSecondary"
      className={styles.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

export const inputComponent = React.forwardRef(function InputComponent(props: any, ref) {
  // MUI v5/React 18: ensure ref is forwarded to the DOM node
  return <div ref={ref} {...props} />;
});

export function Option(props: any) {
  return (
    <MenuItem
      classes={{ root: styles.listItem }}
      className={styles.dropdown}
      ref={props.innerRef}
      selected={props.isFocused}
      component="div"
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

export function Placeholder(props: any) {
  return (
    <Typography
      color="textSecondary"
      className={styles.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

export function SingleValue(props: any) {
  return (
    <Typography
      className={styles.singleValue}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

export function ValueContainer(props: any) {
  return <div className={styles.valueContainer}>{props.children}</div>;
}

export function ValueContainerMulti(props: any) {
  return <div className={styles.valueContainerMulti}>{props.children}</div>;
}

export function ValueContainerChips(props: any) {
  return <div className={styles.chips}>{props.children}</div>;
}

export function MultiValue(props: any) {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={styles.chip}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CloseIcon className={styles.deleteChipIcon} {...props.removeProps} />}
    />
  );
}

export function Menu(props: any) {
  return (
    <Paper
      square
      className={styles.paper}
      {...props.innerProps}
    >
      {props.children}
    </Paper>
  );
}

export function DropdownIndicator(props: any) {
  return <KeyboardArrowDown className={styles.iconDrop} />;
}

export function DropdownIndicatorMulti(props: any) {
  return <KeyboardArrowDown className={styles.iconStyle} />;
}

export function IndicatorSeparator(props: any) {
  return <span></span>;
}
